import React, {Component} from "react";
import "./UserAddressTable.css";
import "../../../Common/Common.css";
import EditAddresses from "../UserEditAddress/UserEditAddress";
import DeleteAddresses from '../UserDeleteAddress/UserDeleteAddress';
import AddNewAddress from '../UserAddNewAddress/UserAddNewAddress';
import {FormattedMessage} from "react-intl";
import $ from "jquery";
import canvasDown from "../../../../assets/img/canvasdown.png";
import canvasUp from "../../../../assets/img/canvasup.png";

class UserAddressTable extends Component {

    constructor(props) {
        super(props);

    }

    componentDidMount() {
        var collapsed = true;
        setTimeout(() => {
            $('.btnCollapse').children('.minus').hide()

            $(".btnCollapse").click(function () {
                collapsed = !collapsed;
                if (collapsed) {
                    $(this).children('.minus').hide()
                    $(this).children('.plus').show()
                    $(this).parent().parent().children('.collapseContent').slideUp('slow');
                } else {
                    $(this).children('.plus').hide()
                    $(this).children('.minus').show()
                    $(this).parent().parent().children('.collapseContent').slideDown('slow');
                }
            });
        }, 1000)


    }

    render() {
        let no = 1;
        let noMobile = 1;
        return (
            <div>
                <div className="responsive-userAddress-table">
                    <div className="row">
                        <div className="col-md-12">
                            {/*<span className="add-new-address-title">
                            <FormattedMessage id="app.user-profile.user-address-table.addresses"
                                              defaultMessage="Addresses"
                                              description=""
                            />
                        </span>*/}

                            <AddNewAddress
                                getUserAddresses={this.props.getUserAddresses}
                                userId={this.props.userId}/>

                        </div>
                    </div>

                    <br/>
                    <div className="row info-table-header">
                        <div className="col-md-1">
                            <label>#</label>
                        </div>
                        <div className="col-md-2 no-padding">
                            <label>
                                {/*<FormattedMessage id="app.user-profile.user-profile-info.fname"*/}
                                {/*defaultMessage="First Name"*/}
                                {/*description=""/>*/}
                                <FormattedMessage id="app.user-profile.user-profile-info.name"
                                                  defaultMessage="Name"
                                                  description=""/>
                            </label>
                        </div>
                        {/*<div className="col-md-1">*/}
                        {/*<label>*/}
                        {/*<FormattedMessage id="app.user-profile.user-profile-info.cell.no"*/}
                        {/*defaultMessage="Cell Or MobileNumber"*/}
                        {/*description=""/>*/}
                        {/*</label>*/}
                        {/*</div>*/}
                        <div className="col-md-5">
                            <label>
                                <FormattedMessage id="app.user-profile.user-profile-info.address"
                                                  defaultMessage="Address"
                                                  description=""/>
                            </label>
                        </div>
                        {/*<div className="col-md-2">*/}
                        {/*<label>*/}
                        {/*<FormattedMessage id="app.user-profile.user-profile-info.country"*/}
                        {/*defaultMessage="Country"*/}
                        {/*description=""/>*/}
                        {/*</label>*/}
                        {/*</div>*/}
                        <div className="col-md-2 no-padding">
                            <label>
                                <FormattedMessage id="app.user-profile.user-profile-info.bill-ship"
                                                  defaultMessage="Bill/Ship"
                                                  description=""/>
                            </label>
                        </div>
                        <div className="col-md-2">
                            <label>
                                <FormattedMessage id="app.user-profile.user-profile-info.actions"
                                                  defaultMessage="Actions"
                                                  description=""/>
                            </label>
                        </div>
                    </div>
                    {this.props.userAddresses.length === 0 &&
                    <div className="center-align">
                        <div className="spacer"></div>
                        <h5><FormattedMessage id="app.user-profile.address.no-records"
                                              defaultMessage="No addresses to display"
                                              description=""/></h5>
                    </div>
                    }

                    {this.props.userAddresses.map((item) => {

                        let isShipping = item.addressType.indexOf("SHIPPING") > -1;
                        let isBilling = item.addressType.indexOf("BILLING") > -1;
                        let text = "";
                        if (isBilling && isShipping) {
                            text = <FormattedMessage id="app.address.bill-or-ship-both"
                                                     defaultMessage="bill/ship"
                                                     description=""/>;
                        } else if (isBilling) {
                            text = <FormattedMessage id="app.address.bill"
                                                     defaultMessage="billing"
                                                     description=""/>;
                        } else if (isShipping) {
                            text = <FormattedMessage id="app.address.ship"
                                                     defaultMessage="shipping"
                                                     description=""/>;
                        }

                        return (

                            <div key={item.id}>
                                <hr/>
                                <div className="row">
                                    <div className="col-md-1">
                                        {no++}
                                    </div>
                                    <div className="col-md-2 no-padding">
                                        {item.japaneseLastName}&nbsp;{item.japaneseFirstName}
                                    </div>
                                    {/*<div className="col-md-1">*/}
                                    {/*{item.cellOrMobileNumber}*/}
                                    {/*</div>*/}
                                    <div className="col-md-5">
                                        〒{item.postalCode}&nbsp;{item.province}&nbsp;{item.city}&nbsp;{item.streetAddress}&nbsp;{item.addressLine2}
                                        <br/>
                                    </div>
                                    {/*<div className="col-md-2">*/}
                                    {/*{item.country==="jp" ?*/}
                                    {/*<FormattedMessage id="app.address.country-japan"*/}
                                    {/*defaultMessage="Japan"*/}
                                    {/*description=""/>:<p>{item.country}</p>*/}
                                    {/*}*/}

                                    {/*</div>*/}
                                    <div className="col-md-2 no-padding">
                                        {(text !== "") ?
                                            <span className="label label-primary label-text-responsive-profile">{text}</span> : ""}
                                    </div>
                                    <div className="col-md-2 address-modal-resp-c">

                                        <EditAddresses userInfo={this.props.userInfo}
                                                       addressDetails={item}
                                                       getUserAddresses={this.props.getUserAddresses}
                                                       getUserDetails={this.props.getUserDetails}/>
                                        &nbsp;
                                        <DeleteAddresses addressDetails={item}
                                                         userInfo={this.props.userInfo}
                                                         getUserAddresses={this.props.getUserAddresses}/>

                                    </div>
                                </div>
                            </div>
                        );
                    })}
                </div>

                <div className="responsive-userAddress-table-mobile">
                    <div className="row new-address-resp">
                        <AddNewAddress
                            getUserAddresses={this.props.getUserAddresses}
                            userId={this.props.userId}/>
                        <br/>
                    </div>
                    {this.props.userAddresses.map((item) => {

                        let isShipping = item.addressType.indexOf("SHIPPING") > -1;
                        let isBilling = item.addressType.indexOf("BILLING") > -1;
                        let text = "";
                        if (isBilling && isShipping) {
                            text = <FormattedMessage id="app.address.bill-or-ship-both"
                                                     defaultMessage="bill/ship"
                                                     description=""/>;
                        } else if (isBilling) {
                            text = <FormattedMessage id="app.address.bill"
                                                     defaultMessage="billing"
                                                     description=""/>;
                        } else if (isShipping) {
                            text = <FormattedMessage id="app.address.ship"
                                                     defaultMessage="shipping"
                                                     description=""/>;
                        }

                        return (
                            <div key={item.id}>
                                <div className="row">
                                    <div className="custom-col-12 address-no-color ">
                                        {/*<div className="row">*/}
                                        <div className="custom-col-8 resp-address-no-align">#{noMobile++}</div>
                                        <div className="custom-col-4 float-right-plus btnCollapse">
                                            <span className="plus"><img src={canvasDown} alt="" width='25px'/></span>
                                            <span className="minus"><img src={canvasUp} alt="" width='25px'/></span>
                                        </div>
                                        {/*</div>*/}

                                    </div>
                                    <div className="collapseContent">
                                        <div className="custom-col-12">
                                            <label>
                                                {/*<FormattedMessage id="app.user-profile.user-profile-info.fname"*/}
                                                {/*defaultMessage="First Name"*/}
                                                {/*description=""/>*/}
                                                <FormattedMessage id="app.user-profile.user-profile-info.name"
                                                                  defaultMessage="Name"
                                                                  description=""/>
                                            </label>
                                        </div>
                                        <div className="custom-col-12 responsive-padding">
                                            {item.lastName}&nbsp; {item.firstName}
                                        </div>
                                        <hr className="responsive-hr"/>
                                        <div className="custom-col-12">
                                            <label>
                                                <FormattedMessage id="app.user-profile.user-profile-info.address"
                                                                  defaultMessage="Address"
                                                                  description=""/>
                                            </label>
                                        </div>
                                        <div className="custom-col-12 responsive-padding">
                                            〒{item.postalCode}&nbsp;{item.province}&nbsp;{item.city}&nbsp;{item.streetAddress}&nbsp;{item.addressLine2}
                                            <br/>
                                        </div>
                                        <hr className="responsive-hr"/>
                                        <div className="custom-col-12 responsive-padding">
                                            {(text !== "") ? <div>
                                                    <div className="custom-col-12  ">
                                                        <label>
                                                            <FormattedMessage
                                                                id="app.user-profile.user-profile-info.bill-ship"
                                                                defaultMessage="Bill/Ship"
                                                                description=""/>
                                                        </label>
                                                    </div>
                                                    <p
                                                        className="btn btn-primary user-table-btn-responsive-text">{text}</p>
                                                    <hr className="responsive-hr"/>
                                                    </div>
                                                : ""}
                                        </div>

                                        <div className="custom-col-12">
                                            <label>
                                                <FormattedMessage id="app.user-profile.user-profile-info.actions"
                                                                  defaultMessage="Actions"
                                                                  description=""/>
                                            </label>
                                        </div>
                                        <div className="custom-col-12">

                                            <EditAddresses userInfo={this.props.userInfo}
                                                           addressDetails={item}
                                                           getUserAddresses={this.props.getUserAddresses}
                                                           getUserDetails={this.props.getUserDetails}/>
                                            &nbsp;
                                            <DeleteAddresses addressDetails={item}
                                                             userInfo={this.props.userInfo}
                                                             getUserAddresses={this.props.getUserAddresses}/>

                                        </div>
                                        <hr className="responsive-hr"/>

                                    </div>
                                </div>
                                <br/>
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    }
}

export default UserAddressTable;



// WEBPACK FOOTER //
// ./src/components/Site/UserProfile/UserAddressTable/UserAddressTable.js